import { Component, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { NumberZipcodeQualifierService } from 'src/app/model/api-services/qualifiers/number-zipcode-qualifier.service';
import { StatefulCSS } from 'src/app/model/stateful_css';

@Component({
	selector: 'app-number-zipcode-input',
	templateUrl: './number-zipcode-input.component.html',
	styleUrls: ['./number-zipcode-input.component.scss']
})
export class NumberZipcodeInputComponent extends InputComponent implements OnInit {

	public zipStates: StatefulCSS;
	public zip = 0;
	public plus4 = 0;
	public numericValue = 0;

	ngOnInit() {
		this.zipStates = new StatefulCSS(['short', 'plus4'], this.domNode.nativeElement, 'zip', 'short');
		super.ngOnInit();
	}
	set currentValue(val: any) {
		switch (this.attribute.type) {
			case 'text':
			case 'string':
				this.numericValue = NumberZipcodeQualifierService.FromString(val, this.casting.format);
				break;
			default:
				this.numericValue = this.currentValue;
		}
		let numberString = (this.numericValue === null) ? '' : '' + this.numericValue;
		if (numberString.length > 9) {
			numberString = numberString.substr(0, 9);
		}
		if (numberString.length > 5) {
			this.zip = Number(numberString.substr(0, 5));
			this.plus4 = Number(numberString.substr(5));
		} else {
			this.plus4 = null;
			this.zip = Number(numberString);
		}
		if (this.hasCasting) {
			switch (this.casting.format) {
				case 'zip':
					this.zipStates.SetState('short');
					break;
				case 'zip4':
					this.zipStates.SetState('plus4');
					break;
			}
		}
	}
	get currentValue(): any {
		return super.currentValue;
	}

	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);

		this.currentValue = this.currentValue;


	}
	NumberChanged() {

		switch (this.attribute.type) {
			case 'text':
			case 'string':
				let numberString = '' + this.zip;
				if (this.plus4 !== null) {
					numberString += '' + this.plus4;
				}
				this.currentValue = NumberZipcodeQualifierService.ToString(Number(numberString), this.casting.format);
				break;
			default:
				if (this.zipStates.GetCurrentState() === 'zip') {
					this.currentValue = this.zip;
				} else {
					if (this.plus4 > 0) {
						this.currentValue = Number('' + this.zip + '-' + this.plus4);
					} else {
						this.currentValue = this.zip;
					}
				}
				break;
		}
	}
	Reset() {
		this.numericValue = 0;
	}

	constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

}
